/* eslint-disable */
import { FuseNavigationItem } from "@fuse/components/navigation";
import { production } from "environments/environment.helper";

export const defaultNavigation: FuseNavigationItem[] = [
  {
    id: "home",
    title: "Home",
    type: "basic",
    icon: "nucleo_outline:house-2",
    link: "/home",
  },
  {
    id: "general",
    title: "Desk Booking",
    type: "group",
    children: [
      {
        id: "desk-booking",
        title: "Desk Booking",
        type: "basic",
        icon: "heroicons_outline:clipboard-document-check",
        link: "/booking/overview",
      },
      {
        id: "desk-history",
        title: "History",
        type: "basic",
        icon: "heroicons_outline:calendar",
        link: "/booking/history",
      },
    ],
  },
  {
    id: "report",
    title: "Report",
    type: "group",
    children: [
      {
        id: "analytics",
        title: "Analytics",
        type: "basic",
        icon: "heroicons_outline:chart-pie",
        link: "report/analytics",
      },
      {
        id: "attendance",
        title: "Attendance",
        type: "basic",
        link: "report/attendance/dashboard",
        icon: "heroicons_outline:briefcase",
      },
      {
        id: "timesheet-utilization",
        title: "Timesheet & Utilization",
        type: "basic",
        link: "report/timesheet-utilization",
        icon: "heroicons_outline:document-chart-bar",
      },
    ],
  },
  {
    id: "management",
    title: "Management",
    type: "group",
    children: [
      {
        id: "resource-hub",
        title: "Resource Hub",
        type: "basic",
        icon: "feather:aperture",
        link: "/management/resource-hub",
      },
      {
        id: "project-management",
        title: "Project Suite",
        type: "basic",
        icon: "feather:codesandbox",
        link: "/management/project-management/boards",
        queryParams: { folder: -1 },
        queryParamsHandling: "merge",
      },
      {
        id: "resource-management",
        title: "Business Operations",
        type: "basic",
        icon: "heroicons_outline:banknotes",
        link: "/management/resource-management",
      },
      {
        id: "timesheet",
        title: "Timesheet",
        type: "basic",
        icon: "feather:type",
        link: "management/timesheet",
      },
      {
        id: "approval",
        title: "Approval",
        type: "basic",
        icon: "heroicons_outline:check-badge",
        link: "management/approval",
      },
      {
        id: "banner",
        title: "Ads Gallery",
        type: "basic",
        icon: "heroicons_outline:megaphone",
        link: "management/banner",
      },
    ],
  },
  {
    id: "account-support",
    title: "Account & Support",
    type: "group",
    children: [
      {
        id: "settings",
        title: "Settings",
        type: "basic",
        icon: "heroicons_outline:cog-8-tooth",
        link: "/settings",
      },
      {
        id: "onboarding",
        title: "Onboarding",
        type: "basic",
        icon: "nucleo_outline:magic-wand",
        link: "management/onboarding",
      },
      {
        id: "changelog",

        title: "Changelog",
        type: "basic",
        icon: "heroicons_outline:flag",
        link: "/changelog",
      },
    ],
  },
  {
    id: "dev-tools",
    title: "Dev Tools",
    type: "group",
    hidden: () => production,
    children: [
      {
        id: "icon-viewer",
        title: "Icon Viewer",

        type: "basic",
        icon: "heroicons_outline:command-line",
        link: "/icon-viewer",
      },
    ],
  },
];
export const compactNavigation: FuseNavigationItem[] = [
  {
    id: "dashboards",
    title: "Dashboards",
    tooltip: "Dashboards",
    type: "aside",
    icon: "heroicons_outline:home",
    children: [], // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
  },
  {
    id: "apps",
    title: "Apps",
    tooltip: "Apps",
    type: "aside",
    icon: "heroicons_outline:qrcode",
    children: [], // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
  },
  {
    id: "pages",
    title: "Pages",
    tooltip: "Pages",
    type: "aside",
    icon: "heroicons_outline:document-duplicate",
    children: [], // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
  },
  {
    id: "user-interface",
    title: "UI",
    tooltip: "UI",
    type: "aside",
    icon: "heroicons_outline:collection",
    children: [], // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
  },
  {
    id: "navigation-features",
    title: "Navigation",
    tooltip: "Navigation",
    type: "aside",
    icon: "heroicons_outline:menu",
    children: [], // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
  },
];
export const futuristicNavigation: FuseNavigationItem[] = [
  {
    id: "dashboards",
    title: "DASHBOARDS",
    type: "group",
    children: [], // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
  },
  {
    id: "apps",
    title: "APPS",
    type: "group",
    children: [], // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
  },
  {
    id: "others",
    title: "OTHERS",
    type: "group",
  },
  {
    id: "pages",
    title: "Pages",
    type: "aside",
    icon: "heroicons_outline:document-duplicate",
    children: [], // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
  },
  {
    id: "user-interface",
    title: "User Interface",
    type: "aside",
    icon: "heroicons_outline:collection",
    children: [], // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
  },
  {
    id: "navigation-features",
    title: "Navigation Features",
    type: "aside",
    icon: "heroicons_outline:menu",
    children: [], // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
  },
];
export const horizontalNavigation: FuseNavigationItem[] = [
  {
    id: "dashboards",
    title: "Dashboards",
    type: "group",
    icon: "heroicons_outline:home",
    children: [], // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
  },
  {
    id: "apps",
    title: "Apps",
    type: "group",
    icon: "heroicons_outline:qrcode",
    children: [], // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
  },
  {
    id: "pages",
    title: "Pages",
    type: "group",
    icon: "heroicons_outline:document-duplicate",
    children: [], // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
  },
  {
    id: "user-interface",
    title: "UI",
    type: "group",
    icon: "heroicons_outline:collection",
    children: [], // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
  },
  {
    id: "navigation-features",
    title: "Misc",
    type: "group",
    icon: "heroicons_outline:menu",
    children: [], // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
  },
];
